export const RTKTagNames = {
  USER: 'USER',
  INVESTOR: 'INVESTOR',
  INVESTORS: 'INVESTORS',
  CLIENTS: 'CLIENTS',
  CLIENT: 'CLIENT',
  OBJECTS: 'OBJECTS',
  OBJECT: 'OBJECT',
  BLOCKS: 'BLOCKS',
  BLOCK: 'BLOCK',
  SECTIONS: 'SECTIONS',
  SECTION: 'SECTION',
  EXPENSES: 'EXPENSES',
  EXPENSE: 'EXPENSE',
  ALL_INVESTS: 'ALL_INVESTS',
  STAFFS: 'STAFFS',
  STAFF: 'STAFF',
  PAYMENTS: 'PAYMENTS',
  ACCOUNTANTS: 'ACCOUNTANTS',
  CLIENT_COMMENTS: 'CLIENT_COMMENTS',
  BRON_CLIENTS: 'BRON_CLIENTS',
}
